import React from "react";
import { SITE } from "../lib/site";

const ITEMS = [
  {
    src: SITE.photos.heroExterior,
    alt: "Residential exterior — full home window cleaning, Baton Rouge",
    caption: "Residential exterior",
  },
  {
    src: SITE.photos.detailExterior,
    alt: "Exterior window detail at sunset",
    caption: "Exterior detail",
  },
  {
    src: SITE.photos.interiorBlinds,
    alt: "Interior window before and after cleaning",
    caption: "Interior · Before / After",
  },
  {
    src: SITE.photos.trackBeforeAfter,
    alt: "Window track before and after cleaning",
    caption: "Window tracks · Before / After",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-[#0F4C81] font-bold bg-white/70 backdrop-blur-md px-3 py-1 rounded-full">
            Recent results
          </span>
          <h2 className="mt-4 text-4xl sm:text-5xl font-extrabold text-[#0B2542] leading-tight">
            See the work, not just the words.
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-700">
            Real photos from real Baton Rouge jobs.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5">
          {ITEMS.map((item, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className="group relative rounded-2xl overflow-hidden ring-1 ring-blue-100 bg-white vgc-card-shadow"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={item.src}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                  loading="lazy"
                />
              </div>
              <figcaption className="px-4 py-3 text-sm font-semibold text-[#0B2542] border-t border-blue-50">
                {item.caption}
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="#quote"
            data-testid="gallery-cta"
            className="inline-flex items-center justify-center h-12 px-7 rounded-full bg-[#0F4C81] text-white font-semibold hover:bg-[#0B3A66] transition-colors"
          >
            Get this for your windows
          </a>
        </div>
      </div>
    </section>
  );
}
